// extracted by mini-css-extract-plugin
export var actionIcon = "_pf-0";